import { render, staticRenderFns } from "./PortableGenCard.vue?vue&type=template&id=960cf3ec"
import script from "./PortableGenCard.vue?vue&type=script&lang=js"
export * from "./PortableGenCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Generac.Application.MobileLink\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('960cf3ec')) {
      api.createRecord('960cf3ec', component.options)
    } else {
      api.reload('960cf3ec', component.options)
    }
    module.hot.accept("./PortableGenCard.vue?vue&type=template&id=960cf3ec", function () {
      api.rerender('960cf3ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/PortableGenCard.vue"
export default component.exports